import { render, staticRenderFns } from "./SidebarDetailsOptions.vue?vue&type=template&id=d38b7176&"
import script from "./SidebarDetailsOptions.vue?vue&type=script&lang=js&"
export * from "./SidebarDetailsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports